import { isPlatformBrowser } from '@angular/common';
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // private currentLanguageSubject = new BehaviorSubject<string>('en');
  // public currentLanguage$ = this.currentLanguageSubject.asObservable();
  private defaultLang: string = 'en'; // make it mutable
  private translateService: TranslateService = inject(TranslateService);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.initLanguage();
  }

  private setHtmlLang(lang: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    const html = document.documentElement; // <html>
    html.setAttribute('lang', lang);
  }

  private initLanguage(): void {
    if (isPlatformBrowser(this.platformId)) {
      const savedLang = localStorage.getItem('lng');
      const langToUse = savedLang || this.defaultLang;

      this.translateService.addLangs(['en', 'ar']);
      this.translateService.setFallbackLang(this.defaultLang);
      this.translateService.use(langToUse);

      document.dir = langToUse === 'ar' ? 'rtl' : 'ltr';
      document.body.classList.remove('ar-trans', 'en-trans');
      document.body.classList.add(langToUse === 'ar' ? 'ar-trans' : 'en-trans');
      this.setHtmlLang(langToUse); // ✅ ADD THIS
      localStorage.setItem('lng', langToUse);
    }
  }

  /** Change current app language */
  changeLang(lang: string): void {
    if (!lang) return;
    this.translateService.use(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('lng', lang);
      document.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.body.classList.remove('ar-trans', 'en-trans');
      document.body.classList.add(lang === 'ar' ? 'ar-trans' : 'en-trans');
      this.setHtmlLang(lang); // ✅ ADD THIS
    }
  }

  get currentLang(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('lng') || this.defaultLang;
    }
    return this.defaultLang;
  }

  get drawerPosition(): 'left' | 'right' {
    return this.translateService.getCurrentLang() === 'ar' ? 'left' : 'right';
  }

  //  changeLang(lang: string) {
  //    this.translateService.use(lang);
  //    if (isPlatformBrowser(this.platformId)) {
  //      localStorage.setItem('lng', lang);
  //    }}
  //   // Initialize with saved language
  //   const savedLang = localStorage.getItem('selectedLanguage') || 'en';
  //   this.currentLanguageSubject.next(savedLang);

  //   // Debug: Check Google Translate availability
  //   setTimeout(() => {
  //     this.checkGoogleTranslateStatus();
  //   }, 3000);
  // }

  // private checkGoogleTranslateStatus(): void {
  //   // console.log('=== Google Translate Status ===');
  //   // console.log('Google object:', window.google);
  //   // console.log('Translate element:', document.getElementById('google_translate_element'));
  //   // console.log('Select element:', document.querySelector('#google_translate_element select'));
  //   // console.log('Global translatePage function:', window.translatePage);
  //   // console.log('Current language:', this.getCurrentLanguage());
  //   // console.log('==============================');
  // }

  //   getCurrentLanguage(): string {
  //     return this.currentLanguageSubject.value;
  //   }

  //   translateTo(targetLang: string): void {
  //     // Update current language
  //     this.currentLanguageSubject.next(targetLang);
  //     localStorage.setItem('selectedLanguage', targetLang);

  //     // Set Google Translate cookie
  //     const cookieValue = `/en/${targetLang}`;
  //     document.cookie = `googtrans=${cookieValue}; path=/`;
  //     localStorage.setItem('googtrans', cookieValue);

  //     // Try different methods to trigger translation
  //     this.triggerGoogleTranslate(targetLang);
  //   }

  //   private triggerGoogleTranslate(targetLang: string): void {
  //     console.log('Attempting to translate to:', targetLang);

  //     // Method 1: Use global function if available
  //     if (window.translatePage) {
  //       console.log('Using global translatePage function');
  //       window.translatePage(targetLang);
  //       return;
  //     }

  //     // Method 2: Direct select manipulation
  //     const selectElement = document.querySelector('#google_translate_element select') as HTMLSelectElement;
  //     if (selectElement) {
  //       console.log('Found select element, triggering change');
  //       selectElement.value = targetLang;
  //       selectElement.dispatchEvent(new Event('change', { bubbles: true }));
  //       return;
  //     }

  //     console.log('Select element not found, waiting...');
  //     // Method 3: Wait and try again
  //     setTimeout(() => {
  //       const delayedSelect = document.querySelector('#google_translate_element select') as HTMLSelectElement;
  //       if (delayedSelect) {
  //         console.log('Found delayed select element');
  //         delayedSelect.value = targetLang;
  //         delayedSelect.dispatchEvent(new Event('change', { bubbles: true }));
  //       } else {
  //         console.warn('Google Translate not ready, translation may not work properly');
  //         // Try one more approach - check if Google Translate object exists
  //         if (window.google && window.google.translate) {
  //           console.log('Google Translate API available, trying direct approach');
  //           // Force a page refresh with the cookie set
  //           window.location.reload();
  //         }
  //       }
  //     }, 1000);
  //   }

  //   toggleLanguage(): void {
  //     const currentLang = this.getCurrentLanguage();
  //     const newLang = currentLang === 'en' ? 'ar' : 'en';
  //     this.translateTo(newLang);
  //   }

  //   restoreLanguagePreference(): void {
  //     const savedLanguage = localStorage.getItem('selectedLanguage');
  //     if (savedLanguage && savedLanguage !== 'en') {
  //       // Set cookie without triggering translation (page already loaded with preference)
  //       const cookieValue = `/en/${savedLanguage}`;
  //       document.cookie = `googtrans=${cookieValue}; path=/`;
  //       this.currentLanguageSubject.next(savedLanguage);
  //     }
  //   }

  //   resetLanguage(): void {
  //   // Reset BehaviorSubject
  //   this.currentLanguageSubject.next('en');

  //   // Clear stored language
  //   localStorage.removeItem('selectedLanguage');
  //   localStorage.removeItem('googtrans');

  //   // Reset Google Translate cookie
  //   document.cookie = `googtrans=/en/en; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;

  //   // Force Google Translate back to English if select exists
  //   const selectElement = document.querySelector('#google_translate_element select') as HTMLSelectElement;
  //   if (selectElement) {
  //     selectElement.value = 'en';
  //     selectElement.dispatchEvent(new Event('change', { bubbles: true }));
  //   }
  // }
}
